import { render, staticRenderFns } from "./siteheader.vue?vue&type=template&id=0baa287e&scoped=true"
import script from "./siteheader.vue?vue&type=script&lang=js"
export * from "./siteheader.vue?vue&type=script&lang=js"
import style0 from "./siteheader.vue?vue&type=style&index=0&id=0baa287e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa287e",
  null
  
)

export default component.exports